import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";

// 토큰검사를 하지 않는 페이지들 리스트
const PUBLIC_ROUTES = [
    "/",
    "/UserLoginPg",
    "/UserJoinPg",
    "/UserIdPwFindPg",
    "/UserReviewPg",
    /^\/UserReviewDetailPg\/\d+$/,
    "/UserNoticePg",
    /^\/UserNoticeDtPg\/\d+$/,
    "/UserFaqPg",
    /^\/UserFaqDtPg\/\d+$/,
    "/UserCustomInfoPg",
    "/UserCompareShipPg",
    "/NonUserChatPg",
    "/UserMailInquiryPg",
    "/UserMailSendComplPg",
    "/UserPickupRequestPg",
    "/UserPickupRequestComplPg",
    "/UserUsageGuidePg",
    "/UserPrivacyPolicyPg",
    "/UserTermsPg",
    "/UserSpBoosterPg",
    "/UserWechatPg",
    "/PaymentLoading",
    "/public",

    "/rendered/*",
    /^\/rendered\/.*/,
    /^\/rendered\/.+$/,

    "/btcorpad-login",
    "/btcorpad-join",
    "/btcorpad-pwFind",

    /*
     * [구매대행 API] 상점사(쇼핑몰) 화면 전체
     *
     *  상점사 화면은 비토리지 고객세션과 완전히 분리되어 있다.
     *  검사하는 토큰도(X-STORE-TOKEN) 로그인 화면도(/store/api/login) 다르다.
     *  여기서 고객토큰으로 막으면, 고객 로그인을 먼저 통과해야만
     *  상점사 로그인 화면에 닿을 수 있는 이중관문이 되어버린다.
     *
     *  로그인이 필요한 상점사 화면은 각자 withStoreAuth 가드를 달고 있고
     *  (Dashboard / StoreApiDocsPg / StoreChatPg / StoreMailPg / StoreModifyPg),
     *  연동진입(/store/link)은 스스로 redirectAfterLogin 을 남기고 이동한다.
     *  그러니 이 구역은 통째로 건드리지 않는다.
     */
    /^\/store(\/|$)/,
];

function AppWrapper({ children }) {
    const navigate = useNavigate();
    const location = useLocation();

    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');
    const adminLCAT = localStorage.getItem('adminToken');
    const token = SSAT || LCAT || adminLCAT

    const isPublicRoute = PUBLIC_ROUTES.some(route =>
        typeof route === 'string' ? location.pathname === route : route.test(location.pathname)
    );

    useEffect(() => {
        // 웹쇼핑부스터로부터 유입
        const urlParams = new URLSearchParams(location.search);
        const sessionId = urlParams.get('sessionId');

        if (sessionId) {
            sessionStorage.setItem("sessionId", sessionId);
        }

        if (!token && !isPublicRoute) {
            // 현재 페이지를 세션스토리지에 저장(로그인 후 기존페이지로 이동시키기 위한 목적)
            sessionStorage.setItem("redirectAfterLogin", location.pathname);

            // 로그인 페이지로 이동
            setTimeout(() => {
                if (location.pathname.startsWith('/btcorpad')) {
                    navigate("/btcorpad-login");
                } else {
                    navigate("/UserLoginPg");
                }
            }, 500)

        }
    }, [location, token, navigate]);

    return children;
}

export default AppWrapper
